// CREATE UNSUBMITTED ORDER
export const UNSUBMITTED_CREATE_REQUEST = "UNSUBMITTED_CREATE_REQUEST";
export const UNSUBMITTED_CREATE_SUCCESS = "UNSUBMITTED_CREATE_SUCCESS";
export const UNSUBMITTED_CREATE_FAIL = "UNSUBMITTED_CREATE_FAIL";
export const UNSUBMITTED_CREATE_RESET = "UNSUBMITTED_CREATE_RESET";
